/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

// const marquees = document.querySelectorAll(".wp-block-webuild-marquee");
// marquees.forEach((marquee) => {
// 	let marqueeTL = gsap.timeline({ repeat: -1 });
// let marqueeInner = marquee.querySelector(".marquee-inner");
// 	let marqueeContent = marquee.querySelector("p");

// 	let marqueeWidth = marquee.offsetWidth;
// 	let marqueeContentWidth = marqueeContent.offsetWidth;

// 	let toFill = marqueeWidth / marqueeContentWidth;

// 	for (let i = 0; i < toFill; i++) {
// 		let clone = marqueeContent.cloneNode(true);
// 		marqueeInner.appendChild(clone);
// 	}

// 	marqueeTL.to(marqueeInner, {
// 		x: "-100%",
// 		duration: 15,
// 	});
// });

const init = () => {
	const marquees = document.querySelectorAll(".wp-block-webuild-marquee");

	marquees.forEach((marquee) => {
		if (!marquee) {
			return;
		}
		const duration = 5;
		const marqueeContent = marquee.firstChild;
		if (!marqueeContent) {
			return;
		}

		// let marqueeInner = marquee.querySelector(".marquee-content");
		let marqueeWidth = marquee.offsetWidth;
		// let marqueeContentWidth = marqueeContent.offsetWidth;

		let toFill = marqueeWidth / marqueeContent.offsetWidth;

		for (let i = 0; i < toFill; i++) {
			let marqueeContentClone = marqueeContent.cloneNode(true);
			marquee.append(marqueeContentClone);
		}

		let tween;

		const playMarquee = () => {
			let progress = tween ? tween.progress() : 0;
			tween && tween.progress(0).kill();

			const width = parseInt(
				getComputedStyle(marqueeContent).getPropertyValue("width"),
				10,
			);
			const gap = 96;

			const distanceToTranslate = -1 * (gap + width);

			tween = gsap.fromTo(
				marquee.children,
				{
					x: 0,
				},
				{
					x: distanceToTranslate,
					duration,
					ease: "none",
					repeat: -1,
				},
			);

			tween.progress(progress);
		};

		playMarquee();

		function debounce(func) {
			var timer;
			return function (event) {
				if (timer) clearTimeout(timer);
				timer = setTimeout(
					() => {
						func();
					},
					500,
					event,
				);
			};
		}

		const pauseMarquee = () => {
			tween.pause();
		};

		window.addEventListener("resize", debounce(playMarquee));
		marquee.addEventListener("mouseenter", pauseMarquee);
		marquee.addEventListener("mouseleave", playMarquee);
	});
};

document.addEventListener("DOMContentLoaded", init);
